module.exports = __webpack_public_path__ + "img/botan_pet.6ac4d264.gif";